import { PnpConfig } from "src/pnpframework/lib/interfaces/pnp-config";
import { common } from "./environment.common";
import { globalNav } from './environment.globalnav';

export const environment = {
  production: true,
  dev: false,
  qat: false,
  mocked_all: false,
  mocked_content: true,
  mocked_endpoints: false,
  APPD_KEY: "AD-AAB-ABE-FVX",
  LOGGING_ENABLED: false,
  imgURL: "https://s.tmocache.com",
  SPLUNK_LOGGING: 7,
  APP_ID: "digital-accmgmtAM",
  ENV: "prodAM",
  oktaRedirectUrl:
    "https://accountmanagement.tfb.t-mobile.com/implicit/callback",
  oktaClientId: "0oa84jgfgr3FycN1Z297",
  oktaHost: "https://t-mobile.okta.com",
  OKTA_ISSUER_CODE: "aus84j01313pkZbHk297",
  azureRedirectUrl: 'https://care.ahub.t-mobile.com/',
  ENABLE_OKTA: true,
  B2B_ORG_ID: "1-1NZ0XEL",
  AHUB_USER_ID: "1-1O4IPGO",
  SSO_ON: true,
  ENABLE_ENTITLEMENT: true,
  ENABLE_TEA_API: true,
  ENABLE_BUSINESS_INTERNET: true,
  AUTHORIZED_AD_GROUP_PORT_IN: "OES_SP_BC_UNIV_MGR_dummy",
  ENABLE_UPDATE_LINE_IDENTIFIER: true,
  ENABLE_LINE_DETAILS: true,
  ENABLE_CHANGE_SERVICES: true,
  ENABLE_EVALUATE_PROMOTION: true,
  ENABLE_CANCEL_SUBSCRIBER: true,
  ENABLE_CHANGE_RATE_PLAN: true,
  ENABLE_UNLOCK_STATUS: true,
  ENABLE_END_USER: true,
  ENABLE_AUTHORIZATION: true,
  ENABLE_AHUB_FLOW: true,
  ENABLE_PLAN_AND_SERVICES: true,
  ENABLE_RAHUB_FLOW: true, // redirection Flag for IAM and OKTA
  ENABLE_K2K_SOCS_FLOW: true,
  ENABLE_SUZI_SHEEP: true,
  ENABLE_APPROVAL_DASHBOARD :false, //flag for enabling  approval dashboard screen
  ENABLE_CW_NON_IOT: true,
  ENABLE_IOT: true,
  ENABLE_DIALPAD: true,
  ENABLE_DIALPAD_MULTILINE: true,
  ENABLE_HOMEPAGE_PAGINATION: true,
  ENABLE_SUBSIDY: true,

  ENABLE_ESIM: true,
  ENABLE_PACKAGEDPRODUCT:true,
  ENABLE_MANAGE_PAIRING: true,
  ENABLE_CUP_NOREGRETS_UDF: true,
  ENABLE_CONNECTEDCAR: true,
  ENABLE_APD_ENHANCEMENT: true,
  ENABLE_DIALPAD_3_2:true,
  ENABLE_DH_FILTER:true,
  IOT_CONTROL_CERTER_URL_CARE:
    "https://t-mobile-business-iot.jasper.com/provision/samlconfig/initiate/alias/T-MobileforBusiness_self_serve",
  IOT_CONTROL_CERTER_URL_IAM:
    "https://t-mobile-business-iot.jasper.com/provision/samlconfig/initiate/alias/T-MobileforBusiness_self_serve",
  IOT_CONTROL_MANAGE_PARTNER_PORTAL:'https://iotusermanager.qat03.t-mobile.com/portal',
  UPGRADE_REDIRECT_URL: "https://upgrade.tfb.t-mobile.com",
  SHOP_CATALOG_REDIRECT_URL: "https://shop.tfb.t-mobile.com",
  ORDER_HISTORY_REDIRECT_URL: "https://shop.tfb.t-mobile.com",
  ORDER_APPROVAL_REDIRECT_URL: "https://shop.tfb.t-mobile.com",
  CARTAPP_REDIRECT_URL: "https://shop.tfb.t-mobile.com",
  PAYMENT_REDIRECT_URL: "https://payment.tfb.t-mobile.com",
  EUI_ENDPOINT: "https://account.t-mobile.com/",
  iamRedirectUrl:
    "https://accountmanagement.tfb.t-mobile.com/apps/tfb_acctmgmt/account-management/home",
  iamClientId: "TFBAccountManagement",
  iamClientSecret: "''",
  IAM_LOGOUT: "https://billing.tfb.t-mobile.com",
  OKTA_LOGOUT: "https://care.ahub.t-mobile.com",
  MANAGE_MYDIGITS_URL: "http://mydigits.t-mobile.com/",

  UPGRADE_ENDUSER_REDIRECT_URL:
    "https://tfb.t-mobile.com/skavastream/studio/reader/tmobilesspprod/shopcatalog",
  //Lighthouse AH merge feature flag
  ENABLE_LIGHTHOUSE_IN_AHUB: true,
    // Sidenav URLs (Skava: IAM)
  DASHBOARD_URL_ENDUSER: "https://billing.tfb.t-mobile.com/user",
  DASHBOARD_URL_IAM: "https://billing.tfb.t-mobile.com/dashboard",
  CART_URL_IAM:
    "https://tfb.t-mobile.com/skavastream/studio/reader/tmobilesspprod/yourcart",

  // Sidenav URLs (Angular: IAM/OKTA)
  MANAGE_USERS_URL: "https://usermanagement.t-mobile.com/implicit/manageusers?",
  USER_PROFILE_URL: "https://usermanagement.t-mobile.com/implicit/manageusers?",
  GLOBAL_SETTINGS_URL:
    "https://usermanagement.t-mobile.com/implicit/manageusers?",
  USER_MANAGEMENT: "https://usermanagement.t-mobile.com/",
  BILLING_URL: "https://billing.tfb.t-mobile.com/billing?",
  VIEW_USAGE_DETAILS_BILLING: "https://billing.tfb.t-mobile.com/usage-details?",
  VIEW_USAGE_CHARGES: "https://billing.tfb.t-mobile.com/usage-charges?",
  GN_REDIRECT_URL: "https://tfb.t-mobile.com/implicit/callback",

  // Sidenav URLs (Skava: Care)
  DASHBOARD_URL_OKTA: "https://care.ahub.t-mobile.com/dashboard",
  CART_URL_OKTA: "https://care.ahub.t-mobile.com/yourcart",
  ORG_HOME_URL_OKTA: "https://care.ahub.t-mobile.com/orghome",
  BILLING_URL_OKTA: "https://care.ahub.t-mobile.com/billing?",
  VIEW_USAGE_DETAILS_BILLING_OKTA:
    "https://care.ahub.t-mobile.com/usage-details?",
  VIEW_USAGE_CHARGES_OKTA: "https://care.ahub.t-mobile.com/usage-charges?",
  ENABLE_WALKMEIN: false,
  ...common,
  scriptUrl: "https://tags.tiqcdn.com/utag/tmobile/nextgen/prod/utag.js",
  ENABLE_TAGGING: true,
  ENABLE_SIM_SWAP_IAM: true,
  ENABLE_POP_TOKEN: false,
  DIALPAD: {
    SPECIAL_DIALPAD_PRODUCTS: ['Pro Collaborate', 'Enterprise Collaborate', 'Standard Talk', 'Pro Talk', 'Enterprise Talk']
  },
  ENABLE_SIM_SWAP_FEATURE: true,
  ENABLE_SIM_TO_DEVICE_FEATURE: true,
  ENABLE_ML_PTT_FEATURE: true,
  ENABLE_5G_ANS: true,
  ENABLE_BSS_BI: true,
  ENABLE_SPECTRUM: true,
  ENABLE_DH_UDF: true,
  ENABLE_IDP: true,
  // global nav changes
  PNP_CONFIG: {
    microAppId: "tfb_acctmgmt",
    xhrPrefix: "/xhr/tfb-acctmgmt",
    shouldInjectToken: true,
  } as PnpConfig,
  baseHref: "/apps/tfb_acctmgmt",
  globalNav,

  // BO, IOT
  USER_ROLE: "BO",

  ENABLE_NEW_CONFIGURATION_API: true,
  ENABLE_RATEPLAN_DISABLE_FOR_ISDHFLAG: true,
  ENABLE_STRATEGIC_PORT_IN: true,
  ENABLE_SD_EDGE:false,
  ENABLE_REMOVE_CANCELED_LINES:true,
  // Number of days a strategic port in web url is valid for after being sent
  SP_URL_ACTIVE_DAYS: 30,
    SHOW_FCC_LABEL: true,
  ENABLE_CUP_LINE_IDENTIFIER_MAINTENANCE_POP_UP: true,
  MAINTENANCE_POP_UP_START_DATE: '2024-04-11T20:00:00.999Z',
  MAINTENANCE_POP_UP_END_DATE: '2024-04-12T04:00:00.999Z',
  ENABLE_PARTNER_SUBSCRIPTION_REDEMPTION: true,
  ENABLE_SIM_SWAP_BLOCK: false,
  //Broadband Label
  ENABLE_BROADBAND_LABEL: true,
  ENABLE_COFFEE_JAGUAR: false,

  ENABLE_DIALPAD_FRANCHISE: true,
  ENABLE_UDF_AHUB_2: false
};
